const BASE_URL = process.env.REACT_APP_BASE_URL;
const API_KEY = process.env.REACT_APP_AWS_FRIENDZ_API_KEY;

/**
 * Save a property comparison to the backend
 */
export const saveComparison = async (userId, comparisonName, properties) => {
  try {
    console.log('Making save comparison request to:', `${BASE_URL}/property-comparison`);
    console.log('Request details:', { userId, comparisonName, propertiesCount: properties.length });
    
    const response = await fetch(`${BASE_URL}/property-comparison`, {
      method: 'POST',
      headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        comparisonName,
        properties
      })
    });

    console.log('Response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers.entries()));

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Response error text:', errorText);
      throw new Error(`HTTP ${response.status}: ${errorText || response.statusText}`);
    }

    const data = await response.json();
    console.log('Save comparison successful:', data);
    return data;
  } catch (error) {
    console.error('Error saving comparison:', error);
    console.error('Error type:', error.constructor.name);
    console.error('Error message:', error.message);
    
    // Provide more specific error messages
    if (error.message.includes('Failed to fetch')) {
      throw new Error('Network error - please check your connection and try again');
    }
    if (error.message.includes('CORS')) {
      throw new Error('CORS error - please try refreshing the page and clearing browser cache');
    }
    if (error.message.includes('403')) {
      throw new Error('Access denied - please check your API key configuration');
    }
    
    throw error;
  }
};

/**
 * Get all comparisons for a user
 */
export const getUserComparisons = async (userId) => {
  try {
    const response = await fetch(`${BASE_URL}/property-comparison?userId=${userId}`, {
      headers: {
        'x-api-key': API_KEY
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to get comparisons: ${errorText}`);
    }

    const data = await response.json();
    return data.comparisons || [];
  } catch (error) {
    console.error('Error getting comparisons:', error);
    throw error;
  }
};

/**
 * Get a specific comparison by ID
 */
export const getComparison = async (userId, comparisonId) => {
  try {
    const response = await fetch(`${BASE_URL}/property-comparison?userId=${userId}&comparisonId=${comparisonId}`, {
      headers: {
        'x-api-key': API_KEY
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to get comparison: ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error getting comparison:', error);
    throw error;
  }
};

/**
 * Update a comparison
 */
export const updateComparison = async (userId, comparisonId, updates) => {
  try {
    console.log('Making update comparison request:', { userId, comparisonId, updates });
    
    const response = await fetch(`${BASE_URL}/property-comparison`, {
      method: 'PUT',
      headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        comparisonId,
        ...updates
      })
    });

    console.log('Update response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Update response error text:', errorText);
      throw new Error(`HTTP ${response.status}: ${errorText || response.statusText}`);
    }

    const data = await response.json();
    console.log('Update comparison successful:', data);
    return data;
  } catch (error) {
    console.error('Error updating comparison:', error);
    throw error;
  }
};

/**
 * Delete a comparison
 */
export const deleteComparison = async (userId, comparisonId) => {
  try {
    const response = await fetch(`${BASE_URL}/property-comparison?userId=${userId}&comparisonId=${comparisonId}`, {
      method: 'DELETE',
      headers: {
        'x-api-key': API_KEY
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to delete comparison: ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error deleting comparison:', error);
    throw error;
  }
};